import { render, staticRenderFns } from "./OtpTimeisOver.vue?vue&type=template&id=7143b60e&"
import script from "./OtpTimeisOver.vue?vue&type=script&lang=ts&"
export * from "./OtpTimeisOver.vue?vue&type=script&lang=ts&"
import style0 from "./OtpTimeisOver.vue?vue&type=style&index=0&id=7143b60e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports